var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLocationOffice01 = function SvgLocationOffice01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 49.82,
    y1: 200.81,
    x2: 188.74,
    y2: 33.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 81.28,
    y1: 226.95,
    x2: 220.19,
    y2: 59.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 14.64,
    y1: 171.57,
    x2: 153.56,
    y2: 4.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 36.29,
    y1: 189.56,
    x2: 175.21,
    y2: 22.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 31.43,
    y1: 185.52,
    x2: 170.35,
    y2: 18.37,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 53.08,
    y1: 203.52,
    x2: 192,
    y2: 36.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 48.22,
    y1: 199.48,
    x2: 187.14,
    y2: 32.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 69.87,
    y1: 217.47,
    x2: 208.79,
    y2: 50.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 5.7,
    y1: 164.14,
    x2: 144.62,
    y2: -3.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 15.16,
    y1: 172,
    x2: 154.08,
    y2: 4.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 24.62,
    y1: 179.87,
    x2: 163.54,
    y2: 12.71,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M196.09,187.85h-12.07v-63.03c0-2.16-1.75-3.91-3.91-3.91s-3.91,1.75-3.91,3.91v63.03h-28.05v-32.48c0-2.16-1.75-3.91-3.91-3.91h-25.47c-2.16,0-3.91,1.75-3.91,3.91v32.48h-27.39v-99.79s0,0,0,0V27.05h88.73v63.29c0,2.16,1.75,3.91,3.91,3.91s3.91-1.75,3.91-3.91V23.14c0-2.16-1.75-3.91-3.91-3.91h-9.61v-10.99c0-2.16-1.75-3.91-3.91-3.91h-68.52c-2.16,0-3.91,1.75-3.91,3.91v10.99h-10.6c-2.16,0-3.91,1.75-3.91,3.91v61.01h-30.62v-12.26c0-2.16-1.75-3.91-3.91-3.91h-26.92c-2.16,0-3.91,1.75-3.91,3.91v115.96H3.91c-2.16,0-3.91,1.75-3.91,3.91s1.75,3.91,3.91,3.91h14.32s0,0,0,0h161.89s0,0,0,0h15.97c2.16,0,3.91-1.75,3.91-3.91s-1.75-3.91-3.91-3.91ZM101.99,12.15h60.71v7.08h-60.71v-7.08ZM22.14,75.79h19.1v8.36h-19.1v-8.36ZM55.41,187.85h-9.51v-13.95h9.51v13.95ZM79.68,187.85h-16.45v-17.86c0-2.16-1.75-3.91-3.91-3.91h-17.32c-2.16,0-3.91,1.75-3.91,3.91v17.86h-15.96v-95.89h57.54v95.89ZM140.35,187.85h-17.66v-28.57h17.66v28.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M183.95,107.25c-.05-.25-.13-.5-.23-.73-.1-.24-.22-.46-.36-.67-.07-.11-.15-.21-.23-.31-.08-.1-.17-.19-.26-.28-.09-.09-.18-.18-.28-.26-.1-.08-.2-.16-.31-.23-.21-.14-.44-.26-.68-.36-.23-.1-.48-.17-.73-.23-.13-.02-.25-.04-.38-.06-.26-.03-.52-.03-.77,0-.13.01-.25.03-.38.06-.25.05-.5.13-.73.23-.23.1-.46.22-.67.36-.11.07-.21.15-.31.23-.1.08-.2.17-.29.26-.09.09-.18.19-.26.28-.08.1-.16.2-.23.31-.14.21-.26.44-.36.67-.1.23-.17.48-.22.73-.02.13-.04.25-.06.38-.01.13-.02.25-.02.38s0,.25.02.38c.01.13.03.25.06.38.05.25.13.49.22.73.1.23.22.46.36.67.07.11.15.21.23.31.08.1.17.2.26.29.09.09.18.18.28.26.1.08.2.16.31.23.21.14.44.26.67.36.24.1.48.17.73.22.13.02.25.04.38.06.13.01.26.02.38.02s.26,0,.39-.02c.13-.01.25-.03.38-.06.25-.05.49-.13.73-.22.24-.1.46-.22.67-.36.11-.07.21-.15.31-.23.1-.08.19-.17.28-.26.09-.09.18-.19.26-.29.08-.1.16-.2.23-.31.14-.21.26-.44.36-.67.1-.24.17-.48.23-.73.02-.12.04-.25.06-.38.01-.13.02-.26.02-.38s0-.26-.02-.38c-.01-.13-.03-.25-.06-.38Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.18,44.94c0-2.16-1.75-3.91-3.91-3.91h-16.56c-2.16,0-3.91,1.75-3.91,3.91v16.56c0,2.16,1.75,3.91,3.91,3.91h16.56c2.16,0,3.91-1.75,3.91-3.91v-16.56ZM117.37,57.6h-8.75v-8.75h8.75v8.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M161.79,44.94c0-2.16-1.75-3.91-3.91-3.91h-16.56c-2.16,0-3.91,1.75-3.91,3.91v16.56c0,2.16,1.75,3.91,3.91,3.91h16.56c2.16,0,3.91-1.75,3.91-3.91v-16.56ZM153.97,57.6h-8.75v-8.75h8.75v8.75Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M125.18,79.1c0-2.16-1.75-3.91-3.91-3.91h-16.56c-2.16,0-3.91,1.75-3.91,3.91v16.56c0,2.16,1.75,3.91,3.91,3.91h16.56c2.16,0,3.91-1.75,3.91-3.91v-16.56ZM117.37,91.75h-8.75v-8.75h8.75v8.75Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M161.79,79.1c0-2.16-1.75-3.91-3.91-3.91h-16.56c-2.16,0-3.91,1.75-3.91,3.91v16.56c0,2.16,1.75,3.91,3.91,3.91h16.56c2.16,0,3.91-1.75,3.91-3.91v-16.56ZM153.97,91.75h-8.75v-8.75h8.75v8.75Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M121.27,109.35h-16.56c-2.16,0-3.91,1.75-3.91,3.91v16.56c0,2.16,1.75,3.91,3.91,3.91h16.56c2.16,0,3.91-1.75,3.91-3.91v-16.56c0-2.16-1.75-3.91-3.91-3.91ZM117.37,125.91h-8.75v-8.75h8.75v8.75Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M157.88,109.35h-16.56c-2.16,0-3.91,1.75-3.91,3.91v16.56c0,2.16,1.75,3.91,3.91,3.91h16.56c2.16,0,3.91-1.75,3.91-3.91v-16.56c0-2.16-1.75-3.91-3.91-3.91ZM153.97,125.91h-8.75v-8.75h8.75v8.75Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M34.62,100.96c-2.16,0-3.91,1.75-3.91,3.91v48.94c0,2.16,1.75,3.91,3.91,3.91s3.91-1.75,3.91-3.91v-48.94c0-2.16-1.75-3.91-3.91-3.91Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.62,157.71c2.16,0,3.91-1.75,3.91-3.91v-48.94c0-2.16-1.75-3.91-3.91-3.91s-3.91,1.75-3.91,3.91v48.94c0,2.16,1.75,3.91,3.91,3.91Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M66.62,157.71c2.16,0,3.91-1.75,3.91-3.91v-48.94c0-2.16-1.75-3.91-3.91-3.91s-3.91,1.75-3.91,3.91v48.94c0,2.16,1.75,3.91,3.91,3.91Z"
  })));
};
export default SvgLocationOffice01;